import Vue from "vue";
import GooAnalytics from "./goo-analytics";
import GooFeatures from "./goo-features";

Vue.use(GooAnalytics);
Vue.use(GooFeatures);
